module.exports = __webpack_public_path__ + "img/notify.955dfdfc.svg";